<template>
  <div class="case-settings">
    
    <InputGroup
      title="Set Order Number"
      desc="Please allocate your internal order number here."
      :darkMode="true"
      :oneColumn="true"
      :skipWhiteBox="true"
      >
      <InputText
        label="Order Number"
        type="text"
        v-model="caseForm.enquiry_number"
        autocomplete="disabled"
        :darkMode="true"
        />
    </InputGroup>

    <InputGroup
      title="Set Patient Reference"
      desc="Please allocate your internal patient reference here."
      :darkMode="true"
      :oneColumn="true"
      :skipWhiteBox="true"
      >
      <InputText
        label="Patient Reference"
        type="text"
        v-model="caseForm.patient_reference"
        autocomplete="disabled"
        :darkMode="true"
        />
    </InputGroup>

    <InputGroup
      title="Set Status"
      desc="Once you have reviewed the enquiry, you can set the status to accepted or rejected. You can also Archive the case too."
      :darkMode="true"
      :oneColumn="true"
      :skipWhiteBox="true"
      >
      <InputFancyRadio 
        label="Status"
        :options="statusOptions"
        id="privilegelevel"
        v-model="caseForm.status"
        :darkMode="true"
        />
    </InputGroup>

    <InputGroup
      title="Change Surgeon/Owner"
      desc="This is the primary owner of the case. Meshworks Admins, Distributor Admins and other defined Editors can edit this case in addition to the owner."
      :darkMode="true"
      :oneColumn="true"
      :skipWhiteBox="true"
      v-if="availableUsers != null"
      >

      <MultiSelect
        v-model="caseForm.user"
        :options="availableUsers"
        :singleSelectionOnly="true"
        />
        
    </InputGroup>

    <InputGroup
      title=""
      desc=""
      :skipWhiteBox="true"
      :noLine="true"
      :oneColumn="true"
      :fixedToBottom="true"
      >
      <Button
        label="Save"
        color="green"
        size="large"
        icon="save" 
        @click="submitCaseSettings"
        />
    </InputGroup>

  </div>
</template>

<script>

import InputGroup from "@/Components/InputGroup"
import InputText from "@/Components/InputText"
import InputFancyRadio from "@/Components/InputFancyRadio"
import Button from "@/Components/Button"
import MultiSelect from "@/Components/MultiSelect"

export default {
  props: [
    'thisCase',
    'availableUsers'
  ],
  components: {
    InputGroup,
    InputText,
    InputFancyRadio,
    Button,
    MultiSelect
  },
  data: () => {
    return {
      caseForm: {
        enquiry_number: '',
        patient_reference: '',
        status: '',
        user: ''
      },
      statusOptions: [
        {
          value: 'review',
          text: 'In Review'
        },
        {
          value: 'accepted',
          text: 'Accepted'
        },
        {
          value: 'rejected',
          text: 'Rejected'
        },
      ],
    }
  },
  mounted(){
    this.caseForm.enquiry_number = this.thisCase.enquiry_number
    this.caseForm.patient_reference = this.thisCase.patient_reference
    this.caseForm.status = this.thisCase.status
    this.caseForm.user = this.thisCase.user_id
  },
  methods: {
    submitCaseSettings(){
      let reqFieldCheck = 0

      if(this.caseForm.enquiry_number == null || this.caseForm.enquiry_number == ''){
        this.$toast.error('Please specify an Order Number')
      }else{
        reqFieldCheck++
      }

      if(this.caseForm.patient_reference == null || this.caseForm.patient_reference == ''){
        this.$toast.error('Please specify a Patient Reference')
      }else{
        reqFieldCheck++
      }

      if(reqFieldCheck == 2){
        this.$inertia.post(`/admin/cases/${this.thisCase.hashid}`, this.caseForm)
      }
    },
    selectSetting(setting, allowed){
      if(allowed){
        this.selectedSetting = setting
      }
    },
  }
}

</script>

<style scoped lang="sass">

// .case-settings



</style>